export default "import React from 'react';\nimport { Button } from 'mj-design';\n\nexport default () => (\n  <Button />\n);\n";